import store from './index'

export default function wrapDispatch<T>(actionCreator: T): T {
    // @ts-ignore
    return (...args) => store.dispatch(actionCreator(...args)) as T
}
